import React from 'react';

// To use this component, make sure you have Bootstrap 5 and Font Awesome included in your project's public/index.html file.
// <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet">
// <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" />

// Reusing the same professional styles for consistency
const styles = `
  body {
    background-color: #f7f8fc;
    color: #495057;
  }
  .gradient-text {
    background: linear-gradient(90deg, #f96b2c, #ff4d4d);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
    font-weight: 700;
  }
  .page-container {
      background-color: #ffffff;
      border-radius: 20px;
      box-shadow: 0 8px 30px rgba(0,0,0,0.05);
  }
  .section-icon {
      color: #f96b2c;
      font-size: 2rem;
  }
  .step-number {
      font-size: 1.5rem;
      font-weight: 700;
      color: #f96b2c;
      border: 2px solid #fde0d3;
      border-radius: 50%;
      width: 50px;
      height: 50px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
  }
  .contact-box {
      background-color: #fffaf7;
      border: 1px dashed #fde0d3;
  }
`;

const DeleteData = () => {
  return (
    <>
      <style>{styles}</style>
      <div className="container my-5">
        <div className="text-center mb-5">
          <h1 className="display-4 gradient-text">Data Deletion Instructions</h1>
          <p className="lead text-muted">Follow these steps to remove your data from our services.</p>
        </div>

        <div className="row">
          <div className="col-lg-10 mx-auto">
            <div className="page-container p-4 p-md-5">

              <p className="mb-5 text-secondary">
                We respect your right to control your personal data. Since you use Facebook to log into our service, the primary way to remove your data is by revoking access through your Facebook account. You can also contact us directly for manual deletion.
              </p>

              {/* Section: Facebook Deletion Steps */}
              <h2 className="h4 fw-bold mb-4">
                <i className="fab fa-facebook me-3 section-icon"></i>Option 1: Delete via Facebook
              </h2>
              <p>Follow these steps to remove <strong>Booze247.co.uk</strong> access from your Facebook account. This will prevent us from accessing your data in the future and will signal our systems to delete your information.</p>

              <div className="mt-4">
                {/* Step 1 */}
                <div className="d-flex align-items-start mb-4">
                  <div className="step-number me-4">1</div>
                  <div>
                    <h6 className="fw-bold">Log in to your Facebook Account</h6>
                    <p className="text-muted">Navigate to Facebook and ensure you are logged in.</p>
                  </div>
                </div>
                {/* Step 2 */}
                <div className="d-flex align-items-start mb-4">
                  <div className="step-number me-4">2</div>
                  <div>
                    <h6 className="fw-bold">Go to "Settings & Privacy"</h6>
                    <p className="text-muted">Click the arrow in the top-right corner and select "Settings & Privacy," then click on "Settings."</p>
                  </div>
                </div>
                 {/* Step 3 */}
                <div className="d-flex align-items-start mb-4">
                  <div className="step-number me-4">3</div>
                  <div>
                    <h6 className="fw-bold">Find "Apps and Websites"</h6>
                    <p className="text-muted">On the left-hand menu, scroll down and click on "Apps and Websites."</p>
                  </div>
                </div>
                 {/* Step 4 */}
                <div className="d-flex align-items-start mb-4">
                  <div className="step-number me-4">4</div>
                  <div>
                    <h6 className="fw-bold">Remove Our App</h6>
                    <p className="text-muted">Find <strong>Booze247.co.uk</strong> in the list of apps, select it, and click the "Remove" button. Confirm your choice.</p>
                  </div>
                </div>
              </div>

              <hr className="my-5" />

              {/* Section: Manual Deletion Request */}
              <h2 className="h4 fw-bold mt-5 mb-4">
                <i className="fas fa-envelope-open-text me-3 section-icon"></i>Option 2: Manual Deletion Request
              </h2>
              <p>
                If you prefer, you can request that we manually delete your account data. Please send an email to our support team with the subject line "Data Deletion Request" from the email address associated with your account.
              </p>
              <div className="mt-4 p-4 rounded-3 text-center contact-box">
                  <strong className="d-block">Email us for manual deletion</strong>
                  <a href="mailto:Support@booze247.co.uk?subject=Data Deletion Request" className="text-decoration-none gradient-text h5">Support@booze247.co.uk</a>
              </div>
               <p className="small text-muted mt-3">
                  Please note that it may take up to 30 days to process manual deletion requests. For a quicker result, we recommend using the Facebook removal method.
              </p>


              <div className="mt-5 text-center text-muted">
                  <p className="small">Last updated: June 30, 2025</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

// The main App component to render the Data Deletion page
export default DeleteData